import { render, staticRenderFns } from "./HojaCDXEComponente.vue?vue&type=template&id=06c432da&scoped=true"
import script from "./HojaCDXEComponente.vue?vue&type=script&lang=js"
export * from "./HojaCDXEComponente.vue?vue&type=script&lang=js"
import style0 from "./HojaCDXEComponente.vue?vue&type=style&index=0&id=06c432da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c432da",
  null
  
)

export default component.exports